export default __webpack_public_path__ + "static/ARTE-3-f869b4297336f3aec1e0a9767482ae54.jpg";